import React from "react";
import { CloseButton } from "react-bootstrap";
import ChartDialogMenu, {
  ChartDialogMenuParam,
} from "../common/ChartDialogMenu";
import "../../../../../App.css";

export interface Props extends ChartDialogMenuParam {
  /**
   * ダイアログを表示するの場合true,それ以外の場合falseを設定します
   */
  open: boolean;
  /**
   * 表示するチャートのIDを設定します
   */
  chartid: string;
  /**
   * 閉じるボタンがクリックされた場合に呼び出されます
   */
  onClose?: () => void;
}

/**
 * チャートダイアログを表示します
 * @param {Props} props - ダイアログパラメータ
 * @returns チャートダイアログ
 */
export default function ChartDialog(props: Props) {
  const {
    open,
    chartid,
    onClose,
    edit,
    editMenu,
    onEdit,
    onSave,
    onXZoomUp,
    onXZoomOut,
    onYZoomUp,
    onYZoomOut,
    id,
    x,
    range,
    onRegist,
  } = props;
  const correction =
    !edit || !editMenu ? <span style={{ marginLeft: "25px" }}></span> : "";
  return (
    <dialog open={open} className="dialog-tag-pos">
      <div className="dialog-buttons">
        <div id={chartid}></div>
        <ChartDialogMenu
          edit={edit}
          editMenu={editMenu}
          onEdit={onEdit}
          onSave={onSave}
          onXZoomUp={onXZoomUp}
          onXZoomOut={onXZoomOut}
          onYZoomUp={onYZoomUp}
          onYZoomOut={onYZoomOut}
          id={id}
          x={x}
          range={range}
          onRegist={onRegist}
        />
        {correction}
        <CloseButton onClick={onClose} />
      </div>
    </dialog>
  );
}
